import styled from 'styled-components';
import {HiddenContainer} from '../powerList/styles';
import {IoIosCloseCircleOutline} from 'react-icons/io';

interface ItemProps {
  readonly maxWidth?: string;
  readonly mWidth?: string;
}

export const IpowerBlank = styled.div<ItemProps>`
  border: 1px solid var(--LightGray);
  background-color: #ffffff;
  justify-content: flex-start;
  padding: 14px 0 8px 10px;
  border-radius: 8px;
  max-width: ${props => props.maxWidth};
  overflow-x: auto;
  display: flex;
`;

export const IpowerBadge = styled.div`
  background-color: #5d6e81;
  align-items: center;
  border-radius: 4px;

  color: #f7f8fa;
  display: flex;
  padding: 5px;
`;

export const IpowerSpan = styled.span`
  width: max-content;
`;

export const IpowerIcon = styled(IoIosCloseCircleOutline)`
  cursor: pointer;
  margin-left: 5px;
  color: #acb1c0;
  font-size: 20px;
`;

export const IpowerPlaceholder = styled.span`
  color: var(--DarkGray);
`;

export const IpowerContainer = styled.div<ItemProps>`
  position: relative;

  &:hover ${HiddenContainer} {
    display: block;
  }
  ${props => `min-width:${props.mWidth};`}
`;
